import { render, staticRenderFns } from "./ClosingDetail.vue?vue&type=template&id=4591d992"
import script from "./ClosingDetail.vue?vue&type=script&lang=js"
export * from "./ClosingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports